import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from 'app/core/http/api.service';
import { environment as env } from '@env/environment';
import { Location } from '@angular/common';
// import {  HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';

import { CreditHoursService } from '../../shared/services/credit-hours.service';
@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  // private messageSource = new BehaviorSubject<string>(null);
  private messageSource = new BehaviorSubject<string>('');
  currentMessage = this.messageSource.asObservable();

  private authStateSubject = new BehaviorSubject<boolean>(false);
  authState$ = this.authStateSubject.asObservable().pipe(distinctUntilChanged());

  private setLoggedInState(state: boolean) {
    this.authStateSubject.next(state);
  }
  private clearAuthState(): void {
  localStorage.clear();
  sessionStorage.clear();
  this.setLoggedInState(false);
  this.changeMessage('');
}

  constructor(
    private apiServerice: ApiService,
    private cme: CreditHoursService,
    private router: Router
    ,private Location:Location
  ) {
    // Initialize auth state on app load / refresh
    const hasToken = !!localStorage.getItem('token');
    this.setLoggedInState(hasToken);
    if (!hasToken) {
      this.changeMessage('');
    }
  }
  
  changeMessage(fname: string) {
    this.messageSource.next(fname);
  }
  checkPermission() {
    return this.checkJWT();
  }

checkJWT(): boolean {
  const token = localStorage.getItem('token');

  // 1️⃣ No token → redirect to login
  if (!token) {
    this.clearAuthState();

    if (this.Location.path().includes('/mob')) {
      this.router.navigateByUrl('login/mob');
    } else {
      this.router.navigateByUrl('login');
    }

    return false;
  }

  // 2️⃣ Validate token with backend
  const params: any = {
    conference_id: env.selectedEvent,
    token: token,
  };

  this.apiServerice.doPost('jwt', params).subscribe((res: any) => {
    if (res.status === 'error') {
      this.clearAuthState();
      this.router.navigateByUrl('login/OtherDevice');
    } else {
      this.setLoggedInState(true);
    }
  });

  return true;
}
handleMagicLoginSafely(): void {
  const url = new URL(window.location.href);
  const magicToken = url.searchParams.get('token');
  const magicConference = url.searchParams.get('conference_id');

  if (!magicToken || !magicConference) {
    return;
  }

  // Prevent re-handling magic login in the same session
  const handled = sessionStorage.getItem('magic_login_handled');
  if (handled === '1') {
    return;
  }

  // Clear existing auth state safely
  localStorage.removeItem('token');
  localStorage.removeItem('conference_id');

  // Set magic credentials
  localStorage.setItem('token', magicToken);
  localStorage.setItem('conference_id', magicConference);

  this.magicLogin(magicToken, magicConference).subscribe((res: any) => {
    if (res?.status !== 'success') {
      localStorage.removeItem('token');
      localStorage.removeItem('conference_id');
      this.setLoggedInState(false);
      this.changeMessage('');
      this.router.navigateByUrl('login');
      return;
    }

    if (res.token) {
      localStorage.setItem('token', res.token);
    }

    sessionStorage.setItem('magic_login_handled', '1');
    this.setLoggedInState(true);
  });
}
handleMagicLogin(): void {
  const url = new URL(window.location.href);
  const magicToken = url.searchParams.get('token');
  const magicConference = url.searchParams.get('conference_id');

  if (!magicToken || !magicConference) return;

  // 🔥 Force override any existing session
  this.clearAuthState();

  localStorage.setItem('token', magicToken);
  localStorage.setItem('conference_id', magicConference);

  this.magicLogin(magicToken, magicConference).subscribe((res: any) => {
    if (res.status !== 'success') {
      this.clearAuthState();
      this.router.navigateByUrl('login');
      return;
    }

    if (res.token) {
      localStorage.setItem('token', res.token);
    }

    this.setLoggedInState(true);
  });
}


  // NEW MAGIC LOGIN METHOD
  magicLogin(token: string, conference_id: string) {
    const params: any = { token: token, conference_id: conference_id };
    return this.apiServerice.doPost(`jwt`, params);
  }
logout() {
  if (localStorage.getItem('token') != null) {
    const checkin_flag = localStorage.getItem('checkin_flag');
    if (checkin_flag === 'Yes') {
      this.cme.check_out('Yes');
    }
  }

  // Clear all auth state
  localStorage.clear();
  sessionStorage.removeItem('magic_login_handled');

  // Emit reactive logout
  this.setLoggedInState(false);
  this.changeMessage('');

}



}
